import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

document.querySelectorAll('.ProductsSlider').forEach((section) => {
    const swiperEl = section.querySelector('.swiper');
    const columns = parseInt(section.getAttribute('data-columns')) || 4;

    new Swiper(swiperEl, {
        modules: [Navigation, Pagination, Autoplay],
        loop: false,
        speed: 700,
        spaceBetween: 16,
        slidesPerView: 1,
        breakpoints: {
            550: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: columns },
        },
        navigation: {
            nextEl: section.querySelector('.bl-swiper-next-btn'),
            prevEl: section.querySelector('.bl-swiper-prev-btn'),
        },
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    });
});